<div class="container profile">
  <div *ngIf="loadingProfile" style="display: flex; justify-content: center">
    <img style="border-radius: 57px" src="assets/icons/logo-fiser-loading.gif" alt="" width="150px" />
  </div>

  <div *ngIf="!loadingProfile" class="tab-container">
    <mat-tab-group [selectedIndex]="selectedTabIndex">
      <form [formGroup]="form" autocomplete="off">
        <mat-tab label="Datos del Comercio" id="datos-comercio-tab">
          <div class="datos-container" *ngIf="wantToBeOrganismo">
            <div class="datos-del-comercio">
              <div class="datos-del-comercio" style="margin-left: 0px">
                <br />
                <div class="no-editable-inputs">
                  <div class="cont-inputs">
                    <mat-form-field class="input-yaca">
                      <mat-label>Razón social</mat-label>
                      <input
                        matInput
                        formControlName="comercioRS"
                        maxlength="255"
                        [placeholder]="translate('pages.profile.labels.bussines_name')"
                        readonly
                      />
                      <mat-error *ngIf="comercioRS.invalid && comercioRS.dirty">{{ getErrorMessage(8) }} </mat-error>
                    </mat-form-field>

                    <mat-form-field class="input-yaca">
                      <mat-label>Domicilio fiscal</mat-label>
                      <input
                        matInput
                        formControlName="domicilioFiscal"
                        maxlength="255"
                        [placeholder]="translate('pages.profile.labels.legal_address')"
                        readonly
                      />
                      <mat-error *ngIf="domicilioFiscal.invalid && domicilioFiscal.dirty"
                        >{{ getErrorMessage(9) }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="cont-inputs">
                    <mat-form-field class="input-yaca">
                      <mat-label>Servicio</mat-label>
                      <input
                        matInput
                        type="text"
                        name="comercioRubro"
                        formControlName="comercioRubro"
                        maxlength="255"
                        [placeholder]="translate('pages.profile.labels.service_category')"
                        readonly
                      />
                      <mat-error *ngIf="comercioRubro.invalid && comercioRubro.dirty"
                        >{{ getErrorMessage(5) }}
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field class="input-yaca">
                      <mat-label>{{ 'pages.profile.labels.iva_treatment' | translate }}</mat-label>
                      <input
                        matInput
                        formControlName="condicionIVA"
                        [placeholder]="translate('pages.profile.labels.bussines_name')"
                        readonly
                      />
                    </mat-form-field>
                  </div>
                  <div class="cont-inputs">
                    <mat-form-field
                      class="input-yaca"
                      [ngClass]="{ 'campo-cuit-invalido': comercioCuit.invalid && comercioCuit.dirty }"
                    >
                      <mat-label>CUIT*</mat-label>
                      <input
                        tabindex="1"
                        matInput
                        formControlName="comercioCuit"
                        maxlength="13"
                        (input)="cuitInputEventHandler($event.target.value)"
                        readonly
                        [placeholder]="translate('pages.profile.labels.cuit')"
                        mask="00-00000000-0"
                      />
                      <mat-icon *ngIf="searchingCuit" matSuffix>
                        <mat-spinner mode="indeterminate" diameter="25"></mat-spinner>
                      </mat-icon>
                    </mat-form-field>
                    <mat-form-field class="input-yaca">
                      <mat-label>E-mail</mat-label>
                      <input matInput type="text" value="{{ userEmail }}" readonly />
                    </mat-form-field>
                  </div>
                  <div class="text-afip">
                    <span>Datos de AFIP (no editables)</span>
                  </div>
                </div>

                <div class="cont-inputs">
                  <mat-form-field class="input-yaca">
                    <mat-label>Piso</mat-label>
                    <input
                      onlyNumberStrict
                      tabindex="5"
                      maxlength="4"
                      matInput
                      formControlName="departamentoPiso"
                      [placeholder]="translate('pages.profile.labels.dept-floor')"
                    />
                  </mat-form-field>

                  <mat-form-field class="input-yaca">
                    <mat-label>Departamento</mat-label>
                    <input
                      tabindex="5"
                      maxlength="4"
                      matInput
                      formControlName="departamentoNumero"
                      [placeholder]="translate('pages.profile.labels.dept-number')"
                    />
                  </mat-form-field>
                </div>
                <div class="cont-inputs">
                  <mat-form-field class="input-yaca">
                    <mat-label>Nombre de fantasía*</mat-label>
                    <input
                      tabindex="4"
                      #commerceName
                      matInput
                      formControlName="comercioNombre"
                      (keyup)="trimValue($event.target.value, comercioNombre)"
                      maxlength="100"
                      [placeholder]="translate('pages.profile.labels.fantasy_name')"
                    />
                  </mat-form-field>
                </div>
                <div class="cont-inputs">
                  <div class="s-cont-input">
                    <search-place-component
                      tabindex="3"
                      formControlName="domicilioComercial"
                      (selectedEvent)="selectedPlaceEventHandler($event)"
                    ></search-place-component>
                  </div>
                  <mat-form-field class="input-yaca">
                    <mat-label>{{ 'pages.profile.labels.activity' | translate }}</mat-label>
                    <mat-select formControlName="rubro" name="rubro">
                      <mat-option *ngFor="let rubro of rubroOptionsCollection" [value]="rubro.value">
                        {{ rubro.display }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex; justify-content: flex-end">
            <button
              mat-raised-button
              type="submit"
              [disabled]="!getStatusButton()"
              [ngClass]="{ 'button-active': getStatusButton() }"
              (click)="onSubmitHandler(form.value)"
            >
              <div style="display: flex; justify-content: center" class="button-with-spinner">
                {{ 'commons.buttons.save' | translate }}
                <div *ngIf="saving">
                  <mat-spinner [diameter]="20"></mat-spinner>
                </div>
              </div>
            </button>
          </div>
        </mat-tab>
      </form>
      <mat-tab label="CVU/ALIAS">
        <div class="buttons-qr-cvu-container">
          <app-cvu-view [isMobile]="isMobile"></app-cvu-view>
        </div>
      </mat-tab>
      <mat-tab label="Sucursales">
        <app-branches></app-branches>
      </mat-tab>
      <mat-tab label="Responsables">
        <app-responsible></app-responsible>
      </mat-tab>
    </mat-tab-group>
    <div class="terms-container">
      <div class="row termsConditions -ml-2" *ngIf="!isResponsible() && wantToBeOrganismo">
        <mat-checkbox
          [checked]="this.currentUser?.organismo"
          [disabled]="this.currentUser?.organismo"
          (change)="changeStatusCheck()"
        >
        </mat-checkbox>
        <div class="ml-2">
          <span class="tyc-label" (click)="openTyCPopup()">{{ 'pages.profile.labels.aceptTerm' | translate }}</span>
        </div>
      </div>
      <div class="registry-state-body" *ngIf="!loggedUser.isResponsible">
        <em class="registry-icon material-icons" [ngClass]="registryState.colorClass">{{ registryState.icon }}</em>
        <mat-label class="registro-estado">{{ registryState.text }}</mat-label>
      </div>
      <div
        class="d-inline-flex justify-content-between flex-direction-row align-items-center mt-1 delete-account-container"
      >
        <button
          class="m-0 p-0"
          *ngIf="!loggedUser.isResponsible"
          mat-button
          type="button"
          style="color: red"
          (click)="deleteUser()"
        >
          Dar de baja mi cuenta
        </button>
        <div *ngIf="wantToBeOrganismo">
          <button
            *ngIf="!currentUser.organismo"
            mat-button
            type="button"
            style="color: red; margin-right: 1rem; padding: 0px"
            tabindex="1"
            (click)="closeCommerceForm()"
          >
            {{ 'commons.buttons.cancel' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
